// extracted by mini-css-extract-plugin
export var alt = "Incrementor-module--alt--fbed2";
export var container = "Incrementor-module--container--8f935";
export var counter = "Incrementor-module--counter--b8cd8";
export var desktopOnly = "Incrementor-module--desktopOnly--5df8e";
export var inputWrapper = "Incrementor-module--inputWrapper--5f446";
export var main = "Incrementor-module--main--9a987";
export var mobileOnly = "Incrementor-module--mobileOnly--5d910";
export var textLeft = "Incrementor-module--textLeft--7dc61";
export var visuallyHidden = "Incrementor-module--visuallyHidden--369e5";